import React, { useState ,useContext,useEffect} from 'react';
import { ClubFittingContext } from "../../ClubfittingNew/ClubFittingContext";
import { API_URL } from "../../../Api/config";

const VideoUpload2 = ({step, onfilechange,remotefittingimage}) => {

    const [videoURL, setVideoURL] = useState(null);
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        onfilechange(file);
    };

    useEffect(() => {
        
        //setSelectedImage(null);
    }, []);

    // const imageURL = remotefittingimage && remotefittingimage[step]?.swing2 instanceof File
    // ? URL.createObjectURL(remotefittingimage[step].swing2)
    // : null;

    // const imageURL = "http://192.168.1.6:5000/remotefittingvideo/1cada319ea8882c54bd74550d8b89bc9..mp4";
    useEffect(() => {
        if (remotefittingimage && remotefittingimage.remotefittingvideo) {
            const item = remotefittingimage.remotefittingvideo.swing1;
            if (item instanceof File) {
                // If the item is a File object, create an object URL
                setVideoURL(URL.createObjectURL(item));
            } else if (typeof item === 'string') {
                // If the item is a string, assume it's a path and prepend SITE_URL
                setVideoURL(`${API_URL}remotefittingvideo/${item}`);
            } else {
                // Reset imageURL if no valid item is found for the current step
                setVideoURL(null);
            }
        } else {
            setVideoURL(null);
        }
    }, [remotefittingimage]);


    return (
        <div className="card-video">
            <div className="drop_box">
                <input
                    type="file"
                    accept=".mp4,.avi,.mkv"
                    id={`${step}.swing2.fileID`}
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                />
                {videoURL && (
                    <div className="form">
                        <video key={videoURL} style={{ width: '100%',position: "absolute", top: "0",left: "0",height: "98%", borderRadius: "1.5rem", marginTop: "10px",}} controls>
                            <source src={videoURL + ''} type="video/mp4" />
                        </video>
                    </div>
                )}
                <div className='custom-upload-btn'>
                    {/* <button className="btn-upload" onClick={() => document.getElementById(`${step}.swing2.fileID`).click()}>
                        <img src={require('../../../assets/images/photo-camera.png')} alt="upload" />
                    </button> */}
                </div>
            </div>
        </div>
    );
};

export default VideoUpload2;
